import React from 'react'
import PropTypes from 'prop-types'
import { classNames } from 'utils/utils'

import { Paragraph } from 'components/patterns'
import NodeDelayIndicator from './NodeDelayIndicator'
import { StyledQueryHeader } from './QueryHeader.style'

const QueryHeader = ({
  description,
  className,
  hasTimerDelay,
  countdown,
  playing,
  isSimulating,
  outputting,
  delayActivate,
  delayDeactivate,
}) => (
  <>
    <StyledQueryHeader className={classNames(className, 'logic-node-header')}>
      <Paragraph weight="bold" size="small">
        {description}
      </Paragraph>
      <NodeDelayIndicator
        hasTimerDelay={hasTimerDelay}
        countdown={countdown}
        playing={playing}
        isSimulating={isSimulating}
        outputting={outputting}
        delayActivate={delayActivate}
        delayDeactivate={delayDeactivate}
      />
    </StyledQueryHeader>
  </>
)

QueryHeader.propTypes = {
  description: PropTypes.string,
  className: PropTypes.string,
  hasTimerDelay: PropTypes.bool,
  isSimulating: PropTypes.bool,
  playing: PropTypes.bool,
  outputting: PropTypes.bool,
  countdown: PropTypes.number,
  delayActivate: PropTypes.number,
  delayDeactivate: PropTypes.number,
}

QueryHeader.defaultProps = {
  className: '',
}

export default QueryHeader
